module.exports = __webpack_public_path__ + "img/offer-bkg.bd5b7fcc.png";